import { userService } from "../services";
import { router } from "../helpers";
import { dictionary } from "../helpers";

const jwt = JSON.parse(
  localStorage.getItem(dictionary.constants.authentication.jwt)
);

const status = { loggedIn: jwt != null };

export const authentication = {
  namespaced: true,
  state: { jwt: jwt, status: status },
  actions: {
    login({ commit }, { username, password }) {
      commit("loginRequest", { username });

      return userService.login(username, password).then(
        jwt => {
          commit("loginSuccess", jwt);
          this.dispatch("user/getUser", { userId: jwt.userId }).then(() => {
            this.commit("booking/resetBooking");
            router.replace({ name: "Booking" });
          });
          // this.commit("booking/resetBooking");
          // router.replace({ name: "Booking" });
        },
        error => {
          // console.log(error);
          commit("loginFailure", error);
        }
      );
    },
    logout({ commit }) {
      userService.logout();
      commit("logout");
      this.commit("booking/resetBooking");
    }
  },
  mutations: {
    loginRequest(state, jwt) {
      state.jwt = jwt;
      state.status = { loggingIn: true };
    },
    loginSuccess(state, jwt) {
      state.jwt = jwt;
      state.status = { loggedIn: true };
    },
    loginFailure(state) {
      state.jwt = null;
      state.status = {};
    },
    logout(state) {
      state.jwt = null;
      state.status = {};
      this.commit("user/updateActiveUser", null);
    },
    setDisplayContactDialog(state, display) {
      state.displayContactDialog = display;
    }
  }
};
